var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wc-button",
    {
      staticClass: "btn btn-danger",
      attrs: { disabled: _vm.isDisabled },
      on: { click: _vm.onClick },
    },
    [_vm._v(" " + _vm._s(_vm.label) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }